import React, { useEffect, useState, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { TargetAudienceSection } from './components/TargetAudienceSection';
import { ProblemSection } from './components/ProblemSection';
import { UniqueMechanismSection } from './components/UniqueMechanismSection';
import { BonusSection } from './components/BonusSection';
import { CTASection } from './components/CTASection';
import { TransformationSection } from './components/TransformationSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { StickyBottomBar } from './components/StickyBottomBar';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { initPixel } from './utils/pixel';
export function App() {
  const [bannerTime, setBannerTime] = useState(2 * 3600 + 10 * 60 + 52); // 02:10:52
  useEffect(() => {
    const timer = setInterval(() => {
      setBannerTime(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatBannerTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  useEffect(() => {
    document.title = 'Rescate Clave de Paz | Salva tu relación';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute('content', 'Descubre el método práctico para reconstruir la comunicación, sanar heridas y blindar tu pareja contra las crisis financieras y el agotamiento mental.');
    } else {
      const newMeta = document.createElement('meta');
      newMeta.name = 'description';
      newMeta.content = 'Descubre el método práctico para reconstruir la comunicación, sanar heridas y blindar tu pareja contra las crisis financieras y el agotamiento mental.';
      document.head.appendChild(newMeta);
    }
    initPixel();
  }, []);
  return <div className="w-full min-h-screen bg-[#110038] text-white font-sans" data-id="element-0">
      {/* Urgency Banner */}
      <div className="w-full bg-[#7C3AED] text-white py-3 px-4 text-center font-sans" data-id="element-1">
        <p className="text-sm md:text-base font-semibold tracking-wide" data-id="element-2">
          ⏳ OFERTA POR TIEMPO LIMITADO:{' '}
          <span className="text-[#E5A83B]" data-id="element-3">56% OFF</span>
        </p>
        <p className="text-sm md:text-base mt-1" data-id="element-4">
          Precio normal <span className="line-through opacity-70" data-id="element-5">$24.999</span>{' '}
          → HOY <span className="text-[#34D399] font-bold" data-id="element-6">$10.999</span>
          <span className="ml-3 bg-black/30 px-3 py-0.5 rounded-md font-mono font-bold tracking-wider" data-id="element-7">
            {formatBannerTime(bannerTime)}
          </span>
        </p>
      </div>

      <HeroSection data-id="element-8" />

      {/* Wave Divider: Hero (110038) to TargetAudience (0D002B) */}
      <div className="w-full overflow-hidden leading-none bg-[#0D002B]" data-id="element-9">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-full h-[50px] md:h-[100px]" data-id="element-10">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#110038" data-id="element-11"></path>
        </svg>
      </div>

      <TargetAudienceSection data-id="element-12" />

      {/* Wave Divider: TargetAudience (0D002B) to Problem (0D002B) - wait, let's make TargetAudience 0D002B and Problem 110038? No, let's just remove the wave between them or make TargetAudience 110038. Let's just use the existing wave that goes to ProblemSection, but it expects 110038 above it. */}
      <div className="w-full overflow-hidden leading-none bg-[#0D002B]" data-id="element-13">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-full h-[50px] md:h-[100px]" data-id="element-14">
          <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V0H1200V30.36C1132.19,53.44,1055.71,74.35,985.66,92.83Z" fill="#0D002B" data-id="element-15"></path>
        </svg>
      </div>

      <ProblemSection data-id="element-16" />

      {/* Wave Divider: Problem (0D002B) to UniqueMechanism (110038) */}
      <div className="w-full overflow-hidden leading-none bg-[#110038]" data-id="element-17">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-full h-[50px] md:h-[100px]" data-id="element-18">
          <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V0H1200V30.36C1132.19,53.44,1055.71,74.35,985.66,92.83Z" fill="#0D002B" data-id="element-19"></path>
        </svg>
      </div>

      <UniqueMechanismSection data-id="element-20" />

      {/* Wave Divider: UniqueMechanism (110038) to Bonus (0D002B) */}
      <div className="w-full overflow-hidden leading-none bg-[#0D002B]" data-id="element-21">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-full h-[50px] md:h-[100px]" data-id="element-22">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#110038" data-id="element-23"></path>
        </svg>
      </div>

      <BonusSection data-id="element-24" />

      {/* Wave Divider: Bonus (0D002B) to CTA (110038) */}
      <div className="w-full overflow-hidden leading-none bg-[#110038]" data-id="element-25">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-full h-[50px] md:h-[100px]" data-id="element-26">
          <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V0H1200V30.36C1132.19,53.44,1055.71,74.35,985.66,92.83Z" fill="#0D002B" data-id="element-27"></path>
        </svg>
      </div>

      <CTASection data-id="element-28" />

      {/* Wave Divider: CTA (110038) to Transformation (0D002B) */}
      <div className="w-full overflow-hidden leading-none bg-[#0D002B]" data-id="element-29">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-full h-[50px] md:h-[100px]" data-id="element-30">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#110038" data-id="element-31"></path>
        </svg>
      </div>

      <TransformationSection data-id="element-32" />

      {/* Wave Divider: Transformation (0D002B) to FAQ (110038) */}
      <div className="w-full overflow-hidden leading-none bg-[#110038]" data-id="element-33">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-full h-[50px] md:h-[100px]" data-id="element-34">
          <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V0H1200V30.36C1132.19,53.44,1055.71,74.35,985.66,92.83Z" fill="#0D002B" data-id="element-35"></path>
        </svg>
      </div>

      <FAQSection data-id="element-36" />

      {/* Wave Divider: FAQ (110038) to Footer (0D002B) */}
      <div className="w-full overflow-hidden leading-none bg-[#0D002B]" data-id="element-37">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-full h-[50px] md:h-[100px]" data-id="element-38">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#110038" data-id="element-39"></path>
        </svg>
      </div>

      <Footer data-id="element-40" />
      <StickyBottomBar data-id="element-41" />
      <PurchaseNotifications data-id="element-42" />
    </div>;
}